import React from 'react'
import { useRecoilState, useSetRecoilState } from 'recoil'
import { GetRedesSociais, PortalLogout } from '@/domain/usecases'
import { useAuth, useTheme } from '@/presentation/hooks'
import { Box, Button, ModalBase, Text, isOpenLogoutState, socialMediaState } from '@/presentation/components'
import { styles } from './styles'
import { version } from '../../../../package.json'

type LogoutProps = {
  portalLogout: PortalLogout
  getRedesSociais: GetRedesSociais
}

export const Logout: React.FC<LogoutProps> = ({
  portalLogout,
  getRedesSociais
}) => {
  const theme = useTheme()
  const { logout, getCurrentClient } = useAuth()
  const [isOpen, setOpen] = useRecoilState(isOpenLogoutState)
  const setSocialMedias = useSetRecoilState(socialMediaState)

  const handleLogout = (): void => {
    const codClient = getCurrentClient()
    logout()

    if (codClient?.toString().endsWith('@insidesistemas.com.br')) {
      portalLogout
        .logout({ cliente: codClient?.toString().replace('@insidesistemas.com.br', ''), version })
        .catch(console.error)
    } else {
      portalLogout
        .logout({ cliente: codClient, version })
        .catch(console.error)
    }

    getRedesSociais
      .getRedesSociais()
      .then((socialMedias) => setSocialMedias(socialMedias))
      .catch((error) => console.error('Erro ao atualizar redes sociais:', error))

    setOpen(false)
  }

  const handleClose = (): void => setOpen(false)

  return (
    <ModalBase visible={isOpen} onClose={handleClose}>
      <Box style={styles.container}>
        <Text variant="subtitle1">Tem certeza que deseja sair?</Text>

        <Box style={styles.buttonArea}>
          <Button
            color={theme.colors.shadow}
            tintColor={theme.colors.white}
            variant="text"
            title="CANCELAR"
            onPress={handleClose}
          />
          <Button
            title="SAIR"
            onPress={handleLogout}
            tintColor={theme.colors.white}
            color={theme.colors.success}
          />
        </Box>
      </Box>
    </ModalBase>
  )
}
